export default {
  URLS: {
	TEAM: '/kiosk/teams/',
  },
};